/*@ngInject*/
const FormEditorNavController = function ($scope, $element, $state) {

    $element.addClass('formEditorNav');

    this.isActive = function (buttonName) {
        return $state.includes(buttonName);
    };
};

angular.module('ums.configuration')
    .controller('formEditorNavController', FormEditorNavController);
